export default function getUrlPrefix() {
	const clientUrl = window.location.pathname.split('/')[1];
	return clientUrl;
}